import {parse as parseQueryString} from 'query-string'
import {pipe, prop} from 'ramda'
import creditsafeFavIcon from '@/assets/img/favicons/favicon.ico'
import equifaxFavIcon from '@/assets/img/favicons/equifaxfavicon.ico'

const PARTNER_ID_KEY = 'partnerID'

export const getPartnerIdQuery = pipe(
  parseQueryString,
  prop(PARTNER_ID_KEY),
)

export const getSessionPartnerId = () => sessionStorage.getItem(PARTNER_ID_KEY)
export const storeSessionPartnerId = (partnerId: any) => sessionStorage.setItem(PARTNER_ID_KEY, partnerId)
export const clearSessionPartnerId = () => sessionStorage.removeItem(PARTNER_ID_KEY)

export const cleanPartnerId = (partnerID) => {
  return partnerID || null
}

export const selectPartnerFavIcon = () => {
  const partnerId = getSessionPartnerId()
  switch (partnerId) {
    case 'cs':
      return creditsafeFavIcon
    case 'efx':
      return equifaxFavIcon
    default:
      return creditsafeFavIcon
  }
}



// WEBPACK FOOTER //
// ./src/partnerID.js